import React, { useState } from "react";
import styles from "./style.module.scss";
import IconMVRCore from "Utils/Assets/Images/IconMVRCore.png";
import IconMVRCore1 from "Utils/Assets/Images/IconMVRCore1.png";
import IconMVRCore2 from "Utils/Assets/Images/IconMVRCore2.png";

import CheckCircle2 from "Utils/Assets/Images/CheckCircle2.png";
import MeetUsWrapper from "Components/MeetUsWrapper";

const MVRCoreCoinUtility = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const data = [
        {
            icon: IconMVRCore1,
            title: "Real Estate Investment & Ownership",
            points: [
                "Buy and sell fractional real estate tokens, unlocking global property markets.",
                "Invest in high-value properties with low entry costs.",
            ],
            isFeatured: true,
        },
        {
            icon: IconMVRCore,
            title: "Passive Income Through Staking",
            points: [
                "Stake MVR Core Coin to earn rental yields and property-based rewards.",
                "Backed by real-world real estate, ensuring stability and security.",
            ],
            isFeatured: false,
        },
        {
            icon: IconMVRCore2,
            title: "Secure & Decentralized Real Estate Transactions",
            points: [
                "Eliminate intermediaries with blockchain-powered real estate transfers.",
                "Access a global property market without traditional banking limitations.",
            ],
            isFeatured: false,
        },
    ];

    const animations = ["fade-left", "fade-up", "fade-right"];

    return (
        <section className={styles.root}>
            <MeetUsWrapper>
                <div className={styles.container}>
                    <h2
                        className={styles.heading}
                        data-aos="fade-up"
                        data-aos-duration="800"
                    >
                        What Will MVR Core Coin <br /> Be Used For?
                    </h2>

                    <div className={styles.cardsGrid}>
                        {data.map((item, index) => (
                            <div
                                key={index}
                                className={`${styles.card} ${activeIndex === index
                                        ? styles.activeCard
                                        : ""
                                    }`}
                                onMouseEnter={() => setActiveIndex(index)}
                             
                            >
                                <img src={item.icon} alt={item.title} className={styles.cardIcon} />

                                <h3 className={styles.cardTitle}>
                                    {item.title}
                                </h3>

                                <ul className={styles.pointsList}>
                                    {item.points.map((point, i) => (
                                        <li
                                            key={i}
                                            className={styles.pointItem}
                                        >
                                            <img
                                                src={CheckCircle2}
                                                alt="check"
                                                className={styles.checkIcon}
                                            />
                                            <span>{point}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </MeetUsWrapper>
        </section>
    );
};

export default MVRCoreCoinUtility;
